import React from "react";

const defaultAuthorityData = [{ authority: "", caseBrief: "", reach: "" }];

const LegalAuthoritiesTable = ({ authorityData, setAuthorityData }) => {
  const handleChange = (index, field, value) => {
    const updated = [...authorityData];
    updated[index][field] = value;
    setAuthorityData(updated);
  };

  const addRow = () => {
    setAuthorityData([
      ...authorityData,
      { authority: "", caseBrief: "", reach: "" },
    ]);
  };

  const removeRow = () => {
    if (authorityData.length > 1) {
      setAuthorityData(authorityData.slice(0, -1));
    }
  };

  const cell = {
    border: "1px solid #000",
    padding: "15px",
    textAlign: "left",
    verticalAlign: "top",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const inputStyle = {
    width: "100%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "5px",
    fontSize: "14px",
  };

  return (
    <div>
      <div
        style={{
          overflowX: "auto",
          marginTop: 20,
          border: "1px solid #000",
          overflow: "hidden",
          borderRadius: "8px",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={header}>Name of the authority</th>
              <th style={header}>Brief of the case</th>
              <th style={header}>Corrective action taken</th>
            </tr>
          </thead>
          <tbody>
            {authorityData.map((row, index) => (
              <tr key={index}>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Name"
                    value={row.authority}
                    onChange={(e) =>
                      handleChange(index, "authority", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Details"
                    value={row.caseBrief}
                    onChange={(e) =>
                      handleChange(index, "caseBrief", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Details"
                    value={row.reach}
                    onChange={(e) =>
                      handleChange(index, "reach", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Add/Remove Buttons */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        <button onClick={removeRow} style={removeButtonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={addButtonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

// Styles
const addButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

const removeButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

export default LegalAuthoritiesTable;
